import api from "./api-manager";

const { REACT_APP_API_A39 } = process.env;

export default {
  /**
   * get data of accounts (database main)
   * @param {*} params
   * @returns
   */
  async getBusinessAccount(params) {
    return api.post(
      `/v1/business/account/info`,
      {},
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
};
